import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Switch } from '../ui/switch';
import { AlertCircle, CheckCircle, CalendarX, Truck, Wrench } from 'lucide-react';
import { getEquipmentValidityInfo, formatDate } from './constants';

const EquipmentSelector = ({ 
  equipment,
  selectedIds, 
  onToggle, 
  permitEndDate,
  hasEquipment,
  onHasEquipmentChange
}) => {
  // Ekipman kategorize etme
  const categorizeEquipment = () => {
    const validEquipment = [];
    const invalidEquipment = [];
    
    equipment.forEach(eq => {
      const validityInfo = getEquipmentValidityInfo(eq, permitEndDate);
      if (validityInfo.isValid) {
        validEquipment.push({ equipment: eq, expiryDate: validityInfo.expiryDate });
      } else {
        invalidEquipment.push({ 
          equipment: eq, 
          expiryDate: validityInfo.expiryDate,
          noDate: validityInfo.noDate 
        });
      }
    });
    
    return { validEquipment, invalidEquipment };
  };

  const { validEquipment, invalidEquipment } = categorizeEquipment();

  return (
    <div className="space-y-3 pt-4 border-t">
      <div className="flex items-center justify-between">
        <Label className="flex items-center gap-2">
          <Truck className="h-4 w-4 text-slate-500" />
          İş Ekipmanı Kullanılacak mı?
        </Label>
        <Switch
          checked={hasEquipment}
          onCheckedChange={onHasEquipmentChange}
          data-testid="has-equipment-switch"
        />
      </div>
      
      {hasEquipment && (
        <div className="border rounded-lg p-4 max-h-60 overflow-y-auto space-y-3">
          {equipment.length === 0 ? (
            <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <p className="text-sm text-amber-700 flex items-center gap-2">
                <AlertCircle className="h-4 w-4" />
                Bu firmaya kayıtlı ekipman bulunmamaktadır.
              </p>
            </div>
          ) : (
            <>
              {/* Periyodik muayenesi dolacak ekipmanlar - UYARI */}
              {invalidEquipment.length > 0 && (
                <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg mb-3">
                  <p className="text-sm font-medium text-orange-700 flex items-center gap-2 mb-2">
                    <CalendarX className="h-4 w-4" />
                    Periyodik Muayenesi Geçersiz Ekipmanlar ({invalidEquipment.length})
                  </p>
                  <p className="text-xs text-orange-600 mb-3">
                    Aşağıdaki ekipmanların periyodik muayenesi seçilen tarih aralığında geçersiz:
                  </p>
                  <div className="space-y-2">
                    {invalidEquipment.map(({ equipment: eq, expiryDate, noDate }) => (
                      <div key={eq.id} className="flex items-center gap-2 text-orange-800 bg-orange-100/50 p-2 rounded">
                        {eq.equipment_type === 'arac' ? (
                          <Truck className="h-4 w-4" />
                        ) : (
                          <Wrench className="h-4 w-4" />
                        )}
                        <span className="font-medium text-sm">{eq.name}</span>
                        <span className="text-xs text-orange-600">
                          {noDate ? '- Periyodik muayene tarihi girilmemiş' : `- Geçerlilik: ${formatDate(expiryDate)}`}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Geçerli Ekipmanlar - Checkbox ile */}
              {validEquipment.length > 0 ? (
                <div className="space-y-2">
                  <p className="text-xs font-medium text-emerald-600 flex items-center gap-1">
                    <CheckCircle className="h-3 w-3" />
                    Seçilebilir Ekipmanlar ({validEquipment.length})
                  </p>
                  {validEquipment.map(({ equipment: eq, expiryDate }) => (
                    <div key={eq.id} className="flex items-center gap-2 pl-2">
                      <Checkbox
                        id={`eq-${eq.id}`}
                        checked={selectedIds?.includes(eq.id)}
                        onCheckedChange={() => onToggle(eq.id)}
                      />
                      <Label htmlFor={`eq-${eq.id}`} className="font-normal cursor-pointer text-slate-900 flex items-center gap-2">
                        {eq.equipment_type === 'arac' ? (
                          <Truck className="h-3 w-3 text-slate-400" />
                        ) : (
                          <Wrench className="h-3 w-3 text-slate-400" />
                        )}
                        {eq.name}
                        <span className="text-xs text-slate-500">
                          (Per. Muayene: {formatDate(expiryDate)})
                        </span>
                      </Label>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                  <p className="text-sm text-amber-700 flex items-center gap-2">
                    <AlertCircle className="h-4 w-4" />
                    Seçilen tarih aralığında periyodik muayenesi geçerli ekipman bulunmamaktadır.
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default EquipmentSelector;
